module.exports = __webpack_public_path__ + "static/media/CCBF_Logo.5669217c.PNG";